import type { FaireProductEntity } from "../../entity_types/product";

export const p_n62862hbyr: FaireProductEntity = {
  token: "p_n62862hbyr",
  type: "product",
  name: "Pink Bandana Zip Sweater",
  brandToken: "b_5m4wqw135i",
  brandName: "Panache Apparel Co.",
  imageUrl: "https://cdn.faire.com/fastly/f6f6e92d4112e6051f3f6008c35e1d520d7aea5f7b3f08b4ffccebcab6d22f56.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddde0043ec1978b0e73c30f1932b1e2f079eb13933aeeae708b531d5edd630e2.jpeg",
    "https://cdn.faire.com/fastly/290bebc94f24a522b9df22e6a06844912e475bd68c75711cdad25af14b66eb83.jpeg",
    "https://cdn.faire.com/fastly/fe5d8d6d93db6bf741281a47d49c415bc66fa9e0a69d4f45dfdc248a9fb64a55.jpeg",
    "https://cdn.faire.com/fastly/f5f5586c7dbf1d6d897de3cfe47e6725683c47c219af26ab6e0feb04efee7fa8.jpeg"
  ],
  priceDollars: 33.95,
  description: "Pink Bandana Zip Sweater featuring an allover black bandana-inspired pattern, designed with a classic collar, front zip closure, two front pockets, long sleeves, and a relaxed fit in a soft knit fabric for casual everyday wear or layering.\n\n39% Acrylic, 31% Polyester, 30% Polyamide\n\nPre-pack 1-2-2-2-1 (XS-XL)\n\nMin. Qty: 8",
  tags: [],
  msrpDollars: 84.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:57.521Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
